export const profilMapping = {
  'Marche' : {
    'Forte endurance': 'basic_pedestrian',
    'Endurance normale': 'basic_pedestrian',
    'Marche difficilement': 'basic_pedestrian'
  },
  'Déficience motrice': {
    'Fauteuil roulant électrique': 'cnig_wheelchair_user',
    'Fauteuil roulant manuel': 'cnig_wheelchair_user'
  },
  'Déficience visuelle': {
    'Partielle (malvoyant)': 'cnig_visually_impaired_user',
    'Totale (non-voyant)': 'cnig_visually_impaired_user'
  },
  'Déficience auditive': {
    'Partielle (malentendant)': 'basic_pedestrian',
    'Totale (sourd)': 'basic_pedestrian'
  },
  'Déficience mentale': {
    'Trouble intellectuel': 'basic_pedestrian',
    'Trouble psychique': 'basic_pedestrian',
  }
};


export const convertProfiltForApi = function(profil, condition){

  function getNested(obj, ...args) {
    return args.reduce((obj, level) => obj && obj[level], obj);
  }

  return getNested(profilMapping, profil, condition);
};
